import Beatblox from './Beatblox';

export default Beatblox;
